import { VerifiedUserIcon } from 'ia-react-core';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  margin: auto;
  * {
    display: inline-block;
  }
  padding-bottom: 13px;
  padding-top: 15px;
`;

export const StyledHeader = styled.div`
  background-color: #FFF;
  width: 100%;
  display: flex;
`;

export const StyledIcon = styled(VerifiedUserIcon)`
  margin-bottom: -6px;
  font-weight: bold;
  margin-right: 8px;
`;
